/* eslint-disable */
import {USERS_ERROR} from 'api/constant'
import axios from "axios";
import { message } from 'antd';
import { useDispatch } from 'react-redux'
import { logout } from './hub';

// axios global function setting
export const JsonRequest = (obj) => async dispatch => {
    try{
        const res = await axios(obj.url)
        dispatch( {
            type: obj.type,
            payload: res.data
        })
        if(obj.type==='SEARCHCATEGORY'){
            return {
                "code": 200,
                "status": "Success.",
                "messages": null,
                "data":res?.data?.[obj?.params?.category || ""],
                "pager_info": null
            }
        }else if(obj.type==='GuestGetServiceV2'){
            return {
                "code": 200,
                "status": "Success.",
                "messages": null,
                "data": {
                    "services":res?.data?.[obj?.data?.service_id || ""]
                },
                "pager_info": null
            }
            console.log(res?.data?.[obj?.data?.service_id || ""])
        }else if(obj.type==='GuestGetService'){
            const keyword = obj?.data?.keyword
            const keywords = keyword.split(' ');
            const serviceData = res?.data?.data?.services
            // console.log(keywords, serviceData)
            // if(str.indexOf(st) > -1)
            if(keyword === "" || !keyword){
                return res?.data
            }else{
                function checkIfValuePresent(currRowText) {
                    let isfound = false;
                    for (let i = 0; i < keywords.length; i++) {
                        if (currRowText.toLowerCase().indexOf(keywords[i].toLowerCase()) > -1) {
                            isfound = true;
                            break;
                        }
                    }
                    return isfound;
                }
                // console.log(serviceData)
                const filterData = serviceData.filter(i=>{
                    // console.log(i?.service_info_data_tw?.[0]?.service_name)
                    return (
                        checkIfValuePresent(i?.vendor_name_tw) 
                        || checkIfValuePresent(i?.vendor_name_en) 
                        || checkIfValuePresent(i?.service_info_data_tw?.[0]?.service_name) 
                        || checkIfValuePresent(i?.service_info_data_en?.[0]?.service_name) 
                        || checkIfValuePresent(i?.service_info_data_tw?.[0]?.keyword) 
                        || checkIfValuePresent(i?.service_info_data_en?.[0]?.keyword) 
                        || checkIfValuePresent(i?.service_info_data_tw?.[0]?.description) 
                        || checkIfValuePresent(i?.service_info_data_en?.[0]?.description) 
                        
                    )
                })
                return {
                    "code": 200,
                    "status": "Success.",
                    "messages": null,
                    "data": {
                        "services":filterData
                    },
                    "pager_info": null
                }
            }
        }
        else{
            return res.data
        }
    }
    catch(e){
        message.error(`${localStorage.getItem('lang')==='en'?'Service exception error. Please try again later.':'服務異常，請稍後再試。'}`)
        dispatch( {
            type: USERS_ERROR,
            payload: console.log(e),
        })
        return e.response
    }

}